export default __webpack_public_path__ + "static/media/profile.e0ef8546.jpg";